import { SET_USER, CLEAR_USER, SET_USER_ROLE, SET_AUTH_READY, SET_WHITELISTED_ADMIN, SET_AUTH_BLOCKED, CLEAR_AUTH_BLOCKED } from "../actions/authActions";

const initialState = {
	userName: null,
    userEmail: null,
	authReady: false,
	userRole: null,
    isWhitelistedAdmin: false,
    authBlocked: false
};

export default function authReducer(state = initialState, action: any) {
	switch (action.type) {
		case SET_USER:
			return {
				...state,
				userName: action.payload.name,
                userEmail: action.payload.email
			};
		case SET_USER_ROLE:
			return {
				...state,
				userRole: action.payload,
			};
		case CLEAR_USER:
			return {
				...initialState,
				authReady: true,
			};
        case SET_AUTH_READY:
            return {
                ...state,
                authReady: action.payload,
            };
        case SET_WHITELISTED_ADMIN:
            return {
                ...state,
                isWhitelistedAdmin: action.payload,
            };
        case SET_AUTH_BLOCKED:
			return {
				...state,
				authBlocked: action.payload,
			};
		case CLEAR_AUTH_BLOCKED:
			return {
				...state,
				authBlocked: false,
			};
		default:
			return state;
	}
}
